import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TablePaginationExhibit2 as TablePagination2 } from "../../../common/table/table-pagination.component";
import { requestLogActions } from "./../../../../store/external/request-reducer/request-log.reducer";
import { requestDetailsActions } from "./../../../../store/external/request-reducer/request-details.reducer";
import { REQUEST_SUB_LINKS as RequestTable, TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import "./../request-page.component.css";
import { TablePagination } from "../../../common/details-table/table-pagination.component";

class OrderRequestApprovalTable extends Component {
    constructor(props) {
        super();
    }

    componentDidMount() {
        this.props.isDisplaySearch(false);
        this.props.setActiveRequestTable(RequestTable.approvalRequest.id);
        this.props.fetchRequestLogItems(0, RequestTable.approvalRequest.id);
    }

    componentWillUnmount() {
        this.props.isDisplaySearch(false);
        this.props.setResetSearch();
        this.props.resetRequestLogData();
    }

    openRequestModal = (item) => {
        const { setSelectedRequest, history } = this.props;
        setSelectedRequest(item);
        history.push("ApprovalRequest/RequestDetail/Order/" + item.OrderId);
    };

    onColumnSearch = () => {
        const { fetchRequestLogItems } = this.props;
        fetchRequestLogItems(0, RequestTable.approvalRequest.id);
    }
    resizePage = (pageSize) => {
        const { resizeRequestLogs, fetchRequestLogItems } = this.props;
        resizeRequestLogs(pageSize)
        fetchRequestLogItems(0, RequestTable.approvalRequest.id);
    }

    render() {
        const { orderApprovalLoaded, orderApprovalFetchError, fetchRequestLogItems, fetchSortedRequestData, setRequestSearchValue, orderRequestData } = this.props;
        let noAccess = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MyRequestsRW]);

        return (
            <div>
                {
                    noAccess ?
                        <NoSubscription hideIcon={true} title="Forbidden Access" /> :
                        orderApprovalLoaded ?
                            orderApprovalFetchError ?
                                <span> Error in fetching data. </span> :
                                <TablePagination 
                                    id={RequestTable.approvalRequest.id}
                                    tablePaginationKey={TABLE_PAGINATION_KEY.requestApprovalRequest}
                                    columns={orderRequestData.Headers}
                                    pageList={orderRequestData.Data}
                                    pages={orderRequestData.Pagination}
                                    rowClickAction={this.openRequestModal}
                                    paginationAction={fetchRequestLogItems}
                                    onColumnClick={fetchSortedRequestData}
                                    onColumnSearch={() => { this.onColumnSearch() }}
                                    onColumnSearchChange={setRequestSearchValue}
                                    isColSearchShow={this.props.displaySearch}
                                    totalPage={orderRequestData.Pagination.TotalEntries}
                                    resizePage={this.resizePage}
                                    key="table-pagination-sec"
                                    classNameWrapper="overflow-auto" 
                                />                               
                                 :
                            <div>
                                <NoSubscription customClass="loading-page" title="Loading, Please Wait…" />
                            </div>
                }
            </div>
        );
    }
}

export default connect(
    state => {
        const { requestLog } = state;
        return {
            ...requestLog
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestLogActions, requestDetailsActions),
            dispatch
        )
)(OrderRequestApprovalTable);
